import { useEffect, useMemo, useState } from "react";
import {
  EntryForm,
  Column,
  Input,
  CheckBox,
  Select,
  RichText,
} from "../components/EntryForm";
import Page from "../components/Page";
import MediaUploader from "../components/MediaUploader";

import { GetProfile, UpdateProfile } from "../services/api/profile";
import { GetAppResource, AddAppResource } from "../services/api/app";
import { useUserProvider } from "../providers/UserProvider";
import { useModalProvider } from "../providers/ModalProvider";
import { useLoaderProvider } from "../providers/LoaderProvider";

import { validations } from "../lib/form";

import { useFormik } from "formik";

import { useHistory } from "react-router-dom";

import * as Yup from "yup";
import responseProcessor from "../lib/responseProcessor";
import { nanoid } from "nanoid";
import DataSelector from "../components/DataSelector";
import { Radio } from "antd";
import LimitReached from "../components/modal_contents/LimitReached";
import VersionizerWrapper from "../components/Versionizer";

const ProfileDetail = ({ newProfile, match }) => {
  const vals = {
    name: "",
    title: "",
    business_name: "",
    profile_image_url: "",
    email: "",
    bio: "",
    web_bio: "",
    website_url: "",
    facebook_url: "",
    facebook_id: "",
    twitter_url: "",
    instagram_url: "",
    youtube_url: "",
    linkedin_url: "",
    action_bar_text: "",
    action_bar_url: "",
    directory: null,
    directory_id: null,
    app_profile: false,
    media_metadata: {},
    active:false,
    enterprise_app: null,
    cta_type: "URL CTA",
    cta: null,
    categories: [],
  };

  const [initialValues, setInitialValues] = useState(vals);
  const [topicValues, setTopicValues] = useState([]);
  const [_setIsTopicLoading, setIsTopicLoading] = useState(false);
  const [metadata, setMetadata] = useState({});
  const [data, setData] = useState({
    loading: false,
    data: [],
    count: 0,
    meta_data: {},
  });
  const [isLoading, setIsLoading] = useState(false);

  const { user } = useUserProvider();

  const { showModal, closeModal } = useModalProvider();

  const { doSetShowLoadingModal } = useLoaderProvider();

  const uuid = newProfile ? user.currentApp() : match.params.uuid;

  const history = useHistory();

  const showBusiness = useMemo(() => (user?.app_data?.setup?.enterprise && user?.app_data?.setup?.enterprise_launch_business), [user]);

  const loadData = async () => {
    setData({ ...data, loading: true });
    GetAppResource(user, "profiles")
      .then((res) => res.json())
      .then((jsonData) => {
        setData({
          loading: false,
          data: jsonData.data,
          count: jsonData.data.length,
          meta_data: jsonData?.meta_data,
        });
      });
  };
  
  useEffect(() => {
    if (newProfile) {
      setInitialValues(vals);
    } else {
      setIsLoading(true);
      GetProfile(uuid, user.idToken)
        .then((res) => res.json())
        .then((res) => {
          setInitialValues({
            active: res.data.active,
            name: res.data.name,
            title: res.data.title,
            business_name: res.data.business_name,
            profile_image_url: res.data.profile_image_url,
            email: res.data.email,
            bio: res.data.bio,
            web_bio: res.data.web_bio,
            website_url: res.data.website_url,
            facebook_url: res.data.facebook_url,
            facebook_id: res.data.facebook_id,
            twitter_url: res.data.twitter_url,
            instagram_url: res.data.instagram_url,
            youtube_url: res.data.youtube_url,
            linkedin_url: res.data.linkedin_url,
            action_bar_text: res.data.action_bar_text,
            action_bar_url: res.data.action_bar_url,
            app_profile: res.data.app_profile,
            directory: res.data.directory,
            directory_id: res?.data?.directory?.id,
            enterprise_app: res?.data?.enterprise_app,
            cta_type: res?.data?.cta_type,
            cta: res?.data?.cta,
            categories: res?.data?.categories,
          });
          setMetadata(res.data.media_metadata);
          setIsLoading(false);
        });
    }

    setIsTopicLoading(true);
    GetAppResource(user, "topics")
      .then((res) => res.json())
      .then((res) => {
        setTopicValues(
          res.data.map((topic) => ({ id: topic.id, name: topic.name }))
        );
        setIsTopicLoading(false);

      });

    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    doSetShowLoadingModal(isLoading);
  }, [isLoading]); // eslint-disable-line react-hooks/exhaustive-deps

  const currentAction = newProfile ? "New" : "Edit";
  const currentUrl = newProfile ? "/profiles/new" : `/profiles/${uuid}`;

  let links = [
    { name: "Home", url: "/" },
    { name: "Profiles", url: "/profiles" },
    { name: `${currentAction} Profile`, url: currentUrl },
  ];

  let schema = {
    name: validations.str_req_30,
    title: validations.str_notreq_35,
    business_name: validations.str_notreq_35,
    profile_image_url: Yup.string()
      .nullable()
      .max(255, "Maximum 255 Characters"),
    email: Yup.string()
      .email("Invalid email")
      .max(255, "Maximum 255 Characters"),
    bio: Yup.string().nullable().max(65535, "Maximum 65,535 Characters"),
    web_bio: Yup.string().nullable().max(65535, "Maximum 65,535 Characters"),
    website_url: Yup.string().nullable().max(255, "Maximum 255 Characters"),
    facebook_url: Yup.string().nullable().max(255, "Maximum 255 Characters"),
    facebook_id: Yup.string().nullable().max(255, "Maximum 255 Characters"),
    twitter_url: Yup.string().nullable().max(255, "Maximum 255 Characters"),
    instagram_url: Yup.string().nullable().max(255, "Maximum 255 Characters"),
    youtube_url: Yup.string().nullable().max(255, "Maximum 255 Characters"),
    linkedin_url: Yup.string().nullable().max(255, "Maximum 255 Characters"),
    action_bar_text: Yup.string().nullable().max(50, "Maximum 50 Characters"),
    action_bar_url: Yup.string().nullable().max(255, "Maximum 255 Characters"),
    directory_id: Yup.string().nullable(),
    app_profile: Yup.boolean().nullable(),
    enterprise_app: Yup.object({
      id: Yup.string().nullable(),
      name: Yup.string().nullable(),
    }).nullable(),
    cta_type: Yup.string().required("Required"),
    cta: Yup.object({
      id: Yup.string().nullable(),
      name: Yup.string().nullable(),
    }).nullable(),
  };

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: Yup.object().shape(schema),
    onSubmit: async (values) => {
      let payload = {
        ...values,
        directory: { id: values.directory_id },
      };

      delete payload.directory_id;

      if (["URL CTA", "Launch Business"].includes(payload?.cta_type)) {
        payload.cta = {}
      }

      if (["Preset CTA", "URL CTA"].includes(payload?.cta_type)) {
        payload.enterprise_app = {}
      }

      if (newProfile) {
        AddAppResource(uuid, "profiles", user.idToken, { data: payload}).then(
          (response) => responseProcessorProxy(response, () => {
            const shouldShowLimit =
              user?.app_data?.portal?.free_account && data?.meta_data?.total >= data?.meta_data?.limit;
            if (shouldShowLimit) {
              showModal(
                <LimitReached
                  onClose={closeModal}
                  freeMessage={user?.app_data?.portal?.free_account_message}
                  appId={user?.currentApp()}
                />,
                {
                  maxHeight: "70vh",
                  maxWidth: "50vw",
                }
              );
            }
          })
        );
      } else {
        UpdateProfile(uuid, user.idToken, { data: payload }).then((response) =>
          responseProcessorProxy(response)
        );
      }
    },
  });

  const handleSuccess = () => {
    setIsLoading(false);
    history.push("/profiles")
  };
  
  const handleError = () => {
    setIsLoading(false);
  };

  const responseProcessorProxy = (response, additionalOnSuccess) => {
    responseProcessor({
      response,
      showModal,
      onSuccess: () => {
        handleSuccess();
        if (additionalOnSuccess) {
          additionalOnSuccess();
        }
      },
      onError: handleError,
    });
  };

  return (
    <Page links={links} title={`${currentAction} Profile`}>
      <EntryForm
        isLoading={isLoading}
        formik={formik}
        submitHandler={formik.handleSubmit}
        cancelURL="/profiles"
      >
        <Column>
          <Input name="name" type="input" label="Name" formik={formik} />
          <Input name="title" type="input" label="Title" formik={formik} />
          <Input
            name="business_name"
            type="input"
            label="Business Name"
            formik={formik}
          />
          <MediaUploader
            name="profile_image_url"
            type="text"
            label="Profile Image URL"
            formik={formik}
            metadata={metadata}
            mediaType="image"
          />
          <Input name="email" type="email" label="Email" formik={formik} />
          <RichText
            id="profilesBioEditor"
            name='bio'
            quillName='web_bio'
            type='text'
            label='Bio'
            rows='21'
            formik={formik}
            contentType="profileBio"
          />
          <Input
            name="website_url"
            type="text"
            label="Website URL"
            formik={formik}
          />
          <Input
            name="facebook_url"
            type="text"
            label="Facebook URL"
            formik={formik}
          />
          <Input
            name="facebook_id"
            type="text"
            label="Facebook ID (required for iOS apps)"
            formik={formik}
          />
        </Column>
        <Column>
          <Input
            name="twitter_url"
            type="text"
            label="Twitter URL"
            formik={formik}
          />
          <Input
            name="instagram_url"
            type="text"
            label="Instagram URL"
            formik={formik}
          />
          <Input
            name="youtube_url"
            type="text"
            label="YouTube URL"
            formik={formik}
          />
          <Input
            name="linkedin_url"
            type="text"
            label="LinkedIn URL"
            formik={formik}
          />

          <div className="flex flex-row w-full justify-between pb-4">
            <label
              className={`text-lg mb-5`}
              htmlFor={"cta_type"}
            >
              CTA Type
              <span style={{ color: "red" }}> *</span>
            </label>
            <Radio.Group
              formik={formik}
              className="flex flex-row"
              value={formik?.values?.cta_type ?? "URL CTA"}
              onChange={event => {
                formik.setFieldValue("cta_type", event.target.value)
                formik.setFieldValue("cta", null)
                formik.setFieldValue("action_bar_text", "")
                formik.setFieldValue("action_bar_url", "")
                formik.setFieldValue("enterprise_app", null)
              }}
            >
              <Radio
                value="URL CTA"
              >
                URL CTA
              </Radio>
              <Radio
                value="Preset CTA"
              >
                Preset CTA
              </Radio>
              {
                user?.app_data?.setup.enterprise_launch_business ? (
                  <Radio
                    value="Launch Business"
                  >
                    Launch Business
                  </Radio>
                ) : null
              }
            </Radio.Group>
          </div>
          {
            !["Preset CTA"].includes(formik.values.cta_type) ? (
              <Input
                name="action_bar_text"
                type="text"
                label={`${formik.values.cta_type === "Launch Business" && showBusiness ? "Launch Business" : ""} Call to Action Text`}
                formik={formik}
              />
            ) : null
          }
          {
            formik.values.cta_type === "Launch Business" && showBusiness ? (
              <DataSelector
                name="enterprise_app"
                formik={formik}
                label="Which Business?"
                resourceEndpoint="children"
                filterOptions={(options) => {
                  return options.filter((a) => a.active );
                }}
                single  
                singleSelectOnly
                withSearch
              />
            ) : null
          }

          {
            !["Preset CTA", "Launch Business"].includes(formik.values.cta_type) ? (
              <Input
                name="action_bar_url"
                type="text"
                label="Call to Action URL"
                formik={formik}
              />
            ) : null
          }

          {
            formik.values.cta_type === "Preset CTA" ? (
              <DataSelector
                name="cta"
                formik={formik}
                label="Call to Action Name List"
                resourceEndpoint="call_to_actions"
                single
                singleSelectOnly
                withSearch
              />
            ) : null
          }

          <div className="flex">
            <span className="flex w-1/3">
              <CheckBox
                name="app_profile"
                label="App Profile?"
                formik={formik}
              />
            </span>
          </div>

          <VersionizerWrapper maxVersion={9}>
            <Select
              name="directory_id"
              type="text"
              label="Topic/Directory Listing"
              formik={formik}
            >
              <option value={null} label="Select Topic..." />
              {topicValues.map((topic) => (
                <option
                  value={topic.id}
                  label={topic.name}
                  selected={
                    formik.values.directory &&
                    topic.id === formik.values.directory.id
                  }
                  key={`option-${nanoid()}`}
                />
              ))}
            </Select>
          </VersionizerWrapper>

          <VersionizerWrapper minVersion={10}>
            <DataSelector
              name="categories"
              formik={formik}
              label="Categories"
              resourceEndpoint="categories"
              sortByName="true"
              filterOptions={(options) => 
                options.filter((status) => status.active)
              }
            />
          </VersionizerWrapper>
          <CheckBox name="active" label="Active" formik={formik} />

        </Column>
      </EntryForm>
    </Page>
  );
};

export default ProfileDetail;
